import { ConfirmOptions, clusterApiUrl, PublicKey } from "@solana/web3.js";

export const network = {
  dev: "https://api.devnet.solana.com",
  main: "https://dawn-red-log.solana-mainnet.quiknode.pro/ff88020a7deb8e7d855ad7c5125f489ef1e9db71/",
}

export const opts: ConfirmOptions = {
  preflightCommitment: "processed",
  commitment: "processed",
  skipPreflight: true,
};

export const logoURI = {
  sol: "https://solana.com/branding/new/logomark/logomark-gradient.svg",
  cys: "https://cdn.jsdelivr.net/gh/solana-labs/token-list/assets/mainnet/BRLsMczKuaR5w9vSubF4j8HwEGGprVAyyVgS4EX7DKEg/logo.svg",
}

// Serum DEX program ID
export const METADATA_PID = new PublicKey("metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s")
export const DEX_PID = new PublicKey("9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin")
export const NFT_MINT = "EJen54s2KzPqgv6rF8wM57re3wDAosYPs552yShoZZfE";

export const REFERRAL_ACCOUNT = new PublicKey("9KiLNBHcDrqYtoRF8tVYZ98hgwNcPgLz8xoRMXwqLQ6Z");
export const CYSaddress = "BRLsMczKuaR5w9vSubF4j8HwEGGprVAyyVgS4EX7DKEg"

// Staking Addresses - Devnet addresses
export const STAKING_PROGRAM = new PublicKey("7XDST8WpuVzZpYqaoVsw5pYJ4NEqvFxkyegx4nK34FMP");
export const DEV_CYS_MINT = new PublicKey("BRLsMczKuaR5w9vSubF4j8HwEGGprVAyyVgS4EX7DKEg");


// No lock period
export const DEV_NO_LOCK_POOL = new PublicKey("C8CJc3Kj3C7eU216jwWUDde3DqPukcko9W39VN1Z99TX");
export const DEV_NO_LOCK_POOL_SIGNER = new PublicKey("8cwZrH7385Nv2TH4xB2qEgxjDsrEXxQ6QqGY2KJvSs6w");
export const DEV_NO_LOCK_NONCE = 252
export const DEV_NO_LOCK_STK_VAULT = new PublicKey("GvWrRhTHYQC2QNG4Hph2bRL5KUqrRoUVmapvzPst96HH");
export const DEV_NO_LOCK_REWARDS_VAULT = new PublicKey("2p9P2i1bdSXyeFHGKMHGb7ixoJDcbTEv6VggHrt7JavK");

// 2 months locking period
export const DEV_2M_LOCK_POOL = new PublicKey("J5YMQTPAbhiyVqYF9kyeWVknfwgciM56moRYXnk3wEcK");
export const DEV_2M_LOCK_POOL_SIGNER = new PublicKey("AcwwkAm1yCxcDKKDdogdoNSt6RzezN3qU4bjVYrG8vbg");
export const DEV_2M_LOCK_NONCE = 251
export const DEV_2M_LOCK_STK_VAULT = new PublicKey("HHvSez6nz1xC1d3E6sGEdXvn7bhsmQP5bGVf5Z7KRJXH");
export const DEV_2M_LOCK_REWARDS_VAULT = new PublicKey("EUCX4QrRZv6iNdnXMmsZfJK7668Rj2nYMpfzEM1w2JvH");

export enum PoolType {
  NOLOCK,
  TWOLOCK,
}